import { folderMatches } from '../utils/formatLib';

export const applySelect = (event, mid, materials, selectedMids, lastSelected, folder) => {
  // Handle a click on a selection check box
  let newSelected = [];

  if (!event.shiftKey) {
    if (!selectedMids.includes(mid)) {
      newSelected = selectedMids.concat(mid);  // Select
    } else {
      newSelected = selectedMids.filter(m => m !== mid);  // Deselect
    }
  } else {
    const lastSelectedMatIndex = materials.findIndex(m => m.materialId === lastSelected);
    const selectedMatIndex = materials.findIndex(m => m.materialId === mid);
    if (lastSelectedMatIndex > -1 && selectedMatIndex > -1) {
      const step = (selectedMatIndex >= lastSelectedMatIndex) ? 1 : -1;
      if (!selectedMids.includes(materials[selectedMatIndex].materialId)) {
        // Block select
        newSelected = selectedMids;
        for (var i = lastSelectedMatIndex; i !== selectedMatIndex + step; i += step) {
          const addMid = materials[i].materialId;
          if (!newSelected.includes(addMid) && materials[i].visible && folderMatches(folder, materials[i].folder)) {
            newSelected.push(addMid);
          }
        }
      } else {
        // Block deselect
        const excludedMids = [];
        for (var i = lastSelectedMatIndex; i !== selectedMatIndex; i += step) {
          excludedMids.push(materials[i].materialId);
        }
        newSelected = selectedMids.filter(m => !excludedMids.includes(m));
      }
    }
  }

  return { newSelected, selectedMid: mid };
};

export async function copySnippet(item, showAlert, format='text') {
  try {
    if (format === 'text') {
      await navigator.clipboard.writeText(item);
    } else {
      // Assume ClipboardItem
      await navigator.clipboard.write([item]);
    }
    showAlert({ status: 'success', message: 'Copied to clipboard', duration: 3000 });
  } catch (e) {
    showAlert({ status: 'error', message: 'Copy to clipboard failed' });
  };
}

export function textureLayerFromIndex(val) {
  const layers = ['render', 'basecolor', 'roughness', 'metallic', 'normals', 'displacement', 'alpha'];
  const index = parseInt(val);
  if (index >= 0 && index < layers.length) {
    return layers[index];
  } else {
    return '';
  }
}
